import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Grid,
  Button,
  CssBaseline,
  TextField,
  Typography,
  LinearProgress,
  FormLabel,
  IconButton,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { Alert, ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/Help';

import ReCAPTCHA from 'react-google-recaptcha';

import { login } from '../../redux/actions/authActions';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  sexo: {
    marginTop: theme.spacing(1),
    width: '100%',
    '& > *': {
      textTransform: 'capitalize',
      width: '50%',
    },
  },
  sexoTitle: {
    marginTop: theme.spacing(1),
  },
  error: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  imgNroTramite: { fontSize: 'inherit' },
  imagen: {
    width: '100%',
  },
  logoApp: {
    width: '65%',
  },
  bg: {
    background: '#01579b',
  },
  colorBg: {
    color: '#01579b',
  },
}));

const recaptchaRef = React.createRef();

const SignIn = ({ auth, loginAction }) => {
  const classes = useStyles();

  const initialFormulario = {
    dni: '',
    nroTramite: '',
    sexo: 'M',
    ftoken: null,
  };

  const dispatch = useDispatch();
  const { error, loading } = useSelector((state) => state.auth);

  const [formulario, setFormulario] = useState(initialFormulario);
  const [open, setOpen] = useState(false);
  const [largoCompletoDni, setLargoCompletoDni] = useState(false);
  const [largoCompletoTra, setLargoCompletoTra] = useState(false);

  const handleForm = (e) => {
    setFormulario({
      ...formulario,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === 'dni' && e.target.value.length === 8) {
      setLargoCompletoDni(true);
    }
    if (e.target.name === 'dni' && e.target.value.length < 8) {
      setLargoCompletoDni(false);
    }
    if (
      e.target.name === 'nroTramite' &&
      e.target.value.length <= 11 &&
      e.target.value.length >= 8
    ) {
      setLargoCompletoTra(true);
    }
    if (e.target.name === 'nroTramite' && e.target.value.length <= 7) {
      setLargoCompletoTra(false);
    }
  };

  const handleSexo = (event, newSexo) => {
    setFormulario({
      ...formulario,
      sexo: newSexo,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const ftoken =
      document.getElementById('ftoken') != null
        ? document.getElementById('ftoken').value
        : null;

    setFormulario({
      ...formulario,
      ftoken,
    });

    recaptchaRef.current.execute();

    // const captcha = '';

    // dispatch(login(formulario, captcha));
    // setFormulario(initialFormulario);
  };

  const onChange = (captcha) => {
    dispatch(login(formulario, captcha));
    setFormulario(initialFormulario);
    setLargoCompletoDni(false);
    setLargoCompletoTra(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={'box-form'}>
      <CssBaseline />
      <div className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <img src='/img/logo-app.png' className={classes.logoApp} alt='logo ' />
          </Grid>
        </Grid>
        {error && (
          <div className={classes.error}>
            <Alert severity='error' align='center'>
              {error.message}
            </Alert>
          </div>
        )}
        {loading ? <LinearProgress /> : null}
        <form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            type='number'
            id='dni'
            label='Nro de Documento'
            name='dni'
            onChange={handleForm}
            value={formulario.dni || ''}
            autoFocus
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 8);
            }}
          />
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            type='number'
            name='nroTramite'
            label='Nro de Tramite'
            id='nroTramite'
            onChange={handleForm}
            value={formulario.nroTramite || ''}
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 11);
            }}
          />
          <FormLabel component='legend' className={classes.imgNroTramite}>
            ¿Donde esta mi Nro de Tramite?
            <IconButton
              aria-label='delete'
              onClick={handleClickOpen}
              className={classes.colorBg}
            >
              <HelpOutlineIcon />
            </IconButton>
          </FormLabel>
          <FormLabel component='legend' className={classes.sexoTitle}>
            Sexo que figura en tu DNI:
          </FormLabel>
          <ToggleButtonGroup
            value={formulario.sexo}
            exclusive
            onChange={handleSexo}
            className={classes.sexo}
            aria-label='Sexo que figura en tu DNI'
          >
            <ToggleButton value='M' aria-label='left aligned'>
              <Typography>Masculino</Typography>
            </ToggleButton>
            <ToggleButton value='F' aria-label='centered'>
              <Typography>Femenino</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
          <Button
            fullWidth
            variant='contained'
            color='primary'
            type='submit'
            value='Submit'
            className={classes.submit}
            disabled={!(largoCompletoDni && largoCompletoTra && formulario.sexo)}
          >
            Ingresar
          </Button>
          <ReCAPTCHA
            ref={recaptchaRef}
            size='invisible'
            sitekey='6LdovvYUAAAAABj2Mkoxu4ZppXpZIpK8RuvvinZ_'
            onChange={onChange}
          />
        </form>
      </div>
      <Box mt={2}></Box>
      <Dialog
        className={classes.form}
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'¿Donde esta mi Nro de Tramite?'}
        </DialogTitle>
        <DialogContent>
          <img
            src='/img/numero_tramite.jpg'
            className={classes.imagen}
            alt='Nro de tramite'
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SignIn;
